function buocSotChiTiet() {
  return [
    {
      target: "body",
      placement: "center",
      title: "Bước 1 · Chi tiết Sọt",
      content: "Xem sức chứa, lịch sử giao dịch và mã QR của một Sọt cụ thể.",
    },
    {
      target: "#tour-sot-chi-tiet-suc-chua",
      title: "Bước 2 · Sức chứa Sọt",
      content:
        "Thanh tiến độ so với sức chứa tối đa của Sọt này (đặt sẵn ở trang Quản lý Sọt) — chuyển màu cảnh báo khi gần đầy hoặc đã đầy 100%, giúp biết còn chứa được bao nhiêu trước khi phải đổi sang Sọt khác.",
      placement: "bottom",
    },
    {
      target: "#tour-sot-chi-tiet-lich-su",
      title: "Bước 3 · Lịch sử giao dịch của Sọt",
      content:
        "Toàn bộ lượt cân đã ghi vào đúng Sọt này. Nếu Sọt đã nhập kho, phần Đối chiếu phía trên còn cho biết chênh lệch giữa khối lượng lúc thu mua và lúc cân lại ở kho.",
      placement: "top",
    },
    {
      target: "#tour-sot-chi-tiet-qr",
      title: "Bước 4 · Mã QR Sọt",
      content:
        "In và dán mã này lên thành Sọt để nhân viên quét khi thu mua và nhập/xuất kho — không cần gõ mã tay. Dùng lại đúng mã này nếu tem cũ đã mờ hoặc rách, không cần tạo Sọt mới.",
      placement: "top",
    },
  ];
}

export default buocSotChiTiet;
